function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoWinner = function SvgNoWinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 1.333 1.333"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.333v1.333H0z",
    style: {
      fill: "#dd3d36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.377.36h.58v.614h-.58z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.377.336.375.338H.369L.367.34H.365L.363.342.36.344.359.346v.002L.357.35v.002L.355.354v.627q0 .002.002.002v.002q0 .002.002.002Q.359.99.36.99v.002q0 .002.002.002h.002q0 .002.002.002h.002q0 .002.002.002h.592L.965.995h.002L.969.993.97.991h.002L.975.99V.987L.977.985.979.983V.356L.977.35V.348L.975.346V.344H.973L.97.342.969.34H.967L.965.338H.96L.959.336H.377M.4.381h.535v.57H.4z",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.666.23a.075.075 0 0 0-.074.072H.55A.03.03 0 0 0 .52.333v.08c0 .018.014.032.031.032h.23A.03.03 0 0 0 .813.414v-.08A.03.03 0 0 0 .781.301H.738A.073.073 0 0 0 .666.23m0 .035c.02 0 .036.017.037.037H.627A.04.04 0 0 1 .666.265",
    style: {
      fill: "#fd5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.557.512.528.541.5.512l-.02.02L.51.56.48.59l.02.02.028-.03.029.03.02-.02L.546.56l.03-.028zM.845.58.817.61.788.58.768.6l.03.028-.03.029.02.02.029-.03.028.03.02-.02L.836.628.865.6z",
    style: {
      fill: "#5b5c5f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.721,
    cy: 0.82,
    r: 0.053,
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#df2c2c",
      strokeWidth: 0.04870946,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.726.575.621.592.64.615a.32.32 0 0 0-.123.248H.56C.56.796.586.717.668.65l.02.026z",
    style: {
      fill: "#df2c2c"
    }
  }));
};
export default SvgNoWinner;